import { useQuery } from "@apollo/client";
import { GET_FINANCE_TREE_TRANSACTION } from "../graphql/queries/financeTransaction.graphql";

interface Media {
  id: number;
  fileName: string;
  originalName: string;
  mimeType: string;
  size: number;
  type: string;
  url: string;
  isActive: boolean;
  altText?: string;
  description?: string;
  width?: number;
  height?: number;
  duration?: number;
  hash?: string;
  tags?: string[];
  expiresAt?: string;
  createdAt: string;
  updatedAt: string;
}

interface TransactionLine {
  id: number;
  transactionId: number;
  financeTreeId: number;
  description?: string;
  debit?: number;
  credit?: number;
  createdAt: string;
  updatedAt: string;
}

interface FinanceTreeTransaction {
  id: number;
  transactionNumber: string;
  date: string;
  description?: string;
  imageId?: number | null;
  totalDebit: number;
  totalCredit: number;
  total: number;
  isBalanced: boolean;
  createdAt: string;
  updatedAt: string;
  image?: Media | null;
  transactionLines: TransactionLine[];
}

interface GetFinanceTreeTransactionVariables {
  id: number;
}

interface GetFinanceTreeTransactionData {
  getFinanceTreeTransaction: FinanceTreeTransaction;
}

export const useFinanceTransaction = (id: number) => {
  return useQuery<GetFinanceTreeTransactionData, GetFinanceTreeTransactionVariables>(
    GET_FINANCE_TREE_TRANSACTION,
    {
      variables: { id },
      skip: !id,
      fetchPolicy: "cache-and-network",
    }
  );
};

